import { twMerge } from 'tailwind-merge';

import { textAlignmentStyle } from '@/_shared';

import { CellText } from './cell-text';
import type { Align } from './types';

export function CellFallbackDangerous({
  className,
  text,
  align = 'left',
}: {
  align?: Align;
  text?: string | number;
  className?: string;
}) {
  console.log('CellFallbackDangerous', text);
  return (
    <CellText
      className={twMerge(textAlignmentStyle[align], className)}
      dangerouslySetInnerHTML={{ __html: text ?? '—' }}
    />
  );
}
